const state = {
  clientHeight: 0,
  clientWidth: 0,
  isMobile: false,
  isGreat2K: false
}

const actions = {}

const mutations = {}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/ui.js